import { render, staticRenderFns } from "./BookingInfo.vue?vue&type=template&id=5f4f7aee&scoped=true"
import script from "./BookingInfo.vue?vue&type=script&lang=ts"
export * from "./BookingInfo.vue?vue&type=script&lang=ts"
import style0 from "./BookingInfo.vue?vue&type=style&index=0&id=5f4f7aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f7aee",
  null
  
)

export default component.exports